import { TrafficType, ProductSegment } from 'api';
import { Option } from 'api';
import { IOptionMapped } from 'api';
import * as actions from './actionTypes';

export const setActiveOptionId = (optionId: number) => ({
	type: actions.SET_ACTIVE_OPTION_ID,
	payload: optionId
});

export const resetActiveOptionId = () => ({
	type: actions.RESET_ACTIVE_OPTION_ID
});

export const setActiveOptionType = (activeOptionTypeId?: number) => ({
	type: actions.SET_ACTIVE_OPTION_TYPE,
	payload: activeOptionTypeId
});

export const setOptionNew = (isNew: boolean) => ({
	type: actions.SET_NEW_OPTION_FLAG,
	payload: isNew
});

export const setActiveTrafficType = (trafficType?: TrafficType) => ({
	type: actions.SET_ACTIVE_TRAFFIC_TYPE,
	payload: trafficType
});

export const setActiveProductType = (prodType?: ProductSegment) => ({
	type: actions.SET_ACTIVE_PRODUCT_TYPE,
	payload: prodType
});

export const resetActiveOptionFilters = () => ({
	type: actions.RESET_ACTIVE_OPTION_FILTERS
});

export const setActiveOptions = (options?: IOptionMapped[]) => ({
	type: actions.SET_ACTIVE_OPTIONS,
	payload: options
});

export const resetActiveOptions = () => ({
	type: actions.RESET_ACTIVE_OPTIONS
});

export const clearActiveOptions = () => ({
	type: actions.CLEAR_ACTIVE_OPTIONS
});

export const addOptionToActiveList = (option: IOptionMapped) => ({
	type: actions.OPTION_WIZARD_ADD_OPTION,
	payload: option
});

export const updateOptionForm = (option: IOptionMapped) => ({
	type: actions.UPDATE_OPTION_FORM,
	payload: option
});

export const resetOptionForm = () => ({
	type: actions.RESET_OPTION_FORM
});

export const getOptions = () => ({
	type: actions.GET_OPTIONS
});

export const getOption = (id: number) => ({
	type: actions.GET_OPTION,
	payload: id
});

export const setOptions = (options: IOptionMapped[]) => ({
	type: actions.SET_OPTIONS,
	payload: options
});

export const insertOption = (option: IOptionMapped[]) => ({
	type: actions.INSERT_OPTION_TO_STORE,
	payload: option
});

export const setOption = (option: Option) => ({
	type: actions.SET_OPTION,
	payload: option
});

export const saveOption = (option: Option) => ({
	type: actions.SAVE_OPTION,
	payload: option
});

export const updateOption = (option: Option) => ({
	type: actions.UPDATE_OPTION,
	payload: option
});

export const optionResetAll = () => ({
	type: actions.OPTION_RESET_ALL
});

export const optionError = (error: string) => ({
	type: actions.OPTION_ERROR,
	payload: error
});

export const optionClearError = () => ({
	type: actions.OPTION_CLEAR_ERROR
});

export const setMBB = (options: IOptionMapped[]) => ({
	type: actions.SET_MBB,
	payload: options
});

export const setFMS = (options: IOptionMapped[]) => ({
	type: actions.SET_FMS,
	payload: options
});

export const resetIsSaved = () => ({
	type: actions.RESET_IS_SAVED
});
